import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getDashboard } from 'utils/api/admin';

const Dashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await getDashboard();
      setStats(res.results);
    } catch (err) {
      console.error(err);
    }
  };

  if (!stats) return <div>로딩 중...</div>;

  return (
    <Container>
      <Title>대시보드</Title>
      <CardGrid>
        <Card>
          <CardLabel>오늘 접속자</CardLabel>
          <CardValue>{stats.todayLoginCount}명</CardValue>
        </Card>
        <Card>
          <CardLabel>총 유저 (활성)</CardLabel>
          <CardValue>{stats.totalUserCount}명</CardValue>
        </Card>
        <Card>
          <CardLabel>휴면 유저</CardLabel>
          <CardValue>{stats.dormantUserCount}명</CardValue>
        </Card>
        <Card>
          <CardLabel>이번달 신규 가입</CardLabel>
          <CardValue>{stats.monthlyNewUsers}명</CardValue>
        </Card>
      </CardGrid>
      <SubTitle>플랜별 유저 수</SubTitle>
      <CardGrid>
        <Card>
          <CardLabel>무료</CardLabel>
          <CardValue>{stats.planCounts?.free || 0}명</CardValue>
        </Card>
        <Card>
          <CardLabel>1단계 (Basic)</CardLabel>
          <CardValue>{stats.planCounts?.basic || 0}명</CardValue>
        </Card>
        <Card>
          <CardLabel>2단계 (Premium)</CardLabel>
          <CardValue>{stats.planCounts?.premium || 0}명</CardValue>
        </Card>
      </CardGrid>
    </Container>
  );
};

const Container = styled.div``;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #232d42;
  margin-bottom: 24px;
`;

const SubTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #232d42;
  margin: 28px 0 16px;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
`;

const CardLabel = styled.div`
  font-size: 13px;
  color: #8f9bba;
  margin-bottom: 8px;
`;

const CardValue = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #232d42;
`;

export default Dashboard;
